import HeaderWithLayoutContext from './Header';

export default HeaderWithLayoutContext;
